// The per-issue parameter picker. A selection is a list of parameter names,
// or null for "all of them" (the default, and what a draft saved before the
// catalog loads means). Order always follows the catalog.

const names = (catalog) => (catalog?.parameters || []).map((p) => p.name);

export function isOn(selection, name) {
  return selection == null || selection.includes(name);
}

export function selectedCount(selection, catalog) {
  const all = names(catalog);
  return selection == null ? all.length : all.filter((n) => selection.includes(n)).length;
}

export function toggle(selection, name, catalog) {
  const all = names(catalog);
  const on = new Set(selection == null ? all : selection);
  if (on.has(name)) on.delete(name);
  else on.add(name);
  return all.filter((n) => on.has(n));
}

export const selectAll = () => null;
export const selectNone = () => [];

/** Standard and local-use groups for the picker, in catalog order. */
export function groups(catalog) {
  const ps = catalog?.parameters || [];
  return [
    { label: "Standard", params: ps.filter((p) => !p.local_use) },
    { label: "Local use", params: ps.filter((p) => p.local_use) },
  ].filter((g) => g.params.length);
}

/** The request's `parameters`: undefined when every parameter is picked. */
export function requestParameters(selection, catalog) {
  if (selection == null) return undefined;
  const all = names(catalog);
  const picked = all.filter((n) => selection.includes(n));
  return picked.length === all.length ? undefined : picked;
}

/** A saved selection, cleaned: unknown names dropped, junk means "all". */
export function restoreSelection(saved) {
  if (!Array.isArray(saved)) return null;
  return saved.filter((n) => typeof n === "string");
}
